import { Outlet } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import CookieBanner from '../components/cookies/CookieBanner';
import CookieWall from '../components/cookies/CookieWall';

const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Main Content */}
      <main className="relative">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />

      <CookieBanner />
      <CookieWall />
    </div>
  );
};

export default PublicLayout; 